import React from "react";
import styled from "styled-components";

const GeneralOverlay = (props) => {
  const handleClick = () => {
    props.toggleGeneralOverlay();
  };
  return (
    <OverlayBlock>
      <MessageBlock>
      <CloseButton className="close" onClick={handleClick}>&times;</CloseButton>
  <Message dangerouslySetInnerHTML={{__html: props.message}}></Message>
      </MessageBlock>
    </OverlayBlock>
  );
};
const CloseButton=styled.span`
    position: absolute;
    top: 0px;
    right: 10px;
    padding: 5px;
    color: #003E8D;
    font-size: 30px;
    font-weight: bold;
    transition: 0.3s;
    &:hover,:focus{
    color: red;
    text-decoration: none;
    cursor: pointer;
    }
`
const OverlayBlock = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99;
`;

const MessageBlock = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
  /* padding: 32px 15px; */
  padding: 32px 15px 32px 0px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;
  font-size:16px;
`;

const Message = styled.div`
  /* padding-bottom: 12px; */
`;

const ActionButton = styled.div`
  width: 100%;
  max-width: 200px;
  margin: 10px auto;
  background: #003e8d;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
`;

export default GeneralOverlay;
